import { render, staticRenderFns } from "./ConfigIntegrationSpecificationsDetails.vue?vue&type=template&id=960b322a&scoped=true&"
import script from "./ConfigIntegrationSpecificationsDetails.vue?vue&type=script&lang=js&"
export * from "./ConfigIntegrationSpecificationsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIntegrationSpecificationsDetails.vue?vue&type=style&index=0&id=960b322a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960b322a",
  null
  
)

export default component.exports